const styles = theme => ({
  root: {
    width: 476,
    maxHeight: 650,
    overflowX: 'auto',
  },
  responseContainer: {
    borderRadius: 6,
    border: '1px solid rgba(145, 158, 171, 0.32)',
    backgroundColor: '#F4F6F8',
    display: 'flex',
    flexDirection: 'row',
    gap: 6,
    alignItems: 'center',
    alignSelf: 'stretch',
    width: '100%',
    minHeight: 24,
    padding: 12,
    lineHeight: '24px',
  },
  loadingText: {
    fontSize: 13,
    color: '#002E47',
  },
  responseText: {
    fontSize: 13,
    color: '#002E47',
    fontFamily: 'Inter',
  },
  buttonContainer: {
    display: 'flex',
    padding: '8px 0px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '4px',
    width: '100%',
  },
})

export default styles
